"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stakingReportSearchValuesCreator = exports.stakingReportColumnsCreator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const date_fns_1 = require("date-fns");
const constants_1 = require("@dzambalaorg/constants");
const mui_scanner_1 = require("@dzambalaorg/mui-scanner");
const types_1 = require("@framework/types");
const types_collection_1 = require("@dzambalaorg/types-collection");
const types_2 = require("../../../../../types");
// prettier-ignore
const stakingReportColumnsCreator = (formatMessage) => [
    {
        field: "id",
        headerName: formatMessage({ id: "form.labels.id" }),
        sortable: true,
        flex: 0.3
    },
    {
        field: "account",
        headerName: formatMessage({ id: "form.labels.account" }),
        sortable: true,
        renderCell: (params) => {
            return ((0, jsx_runtime_1.jsx)(mui_scanner_1.AddressLink, { address: params.value }));
        },
        flex: 2,
        minWidth: 360
    },
    {
        field: "deposit",
        headerName: formatMessage({ id: "form.labels.deposit" }),
        sortable: true,
        flex: 1,
        minWidth: 100
    },
    {
        field: "stakingRule",
        headerName: formatMessage({ id: "form.labels.stakingRule" }),
        sortable: true,
        flex: 1,
        minWidth: 100
    },
    {
        field: "createdAt",
        headerName: formatMessage({ id: "form.labels.createdAt" }),
        sortable: true,
        valueFormatter: (value) => (0, date_fns_1.format)((0, date_fns_1.parseISO)(value), constants_1.humanReadableDateTimeFormat),
        flex: 1,
        minWidth: 160
    }
];
exports.stakingReportColumnsCreator = stakingReportColumnsCreator;
const baseSearchValues = {
    contractId: types_collection_1.InputType.awaited,
    account: "",
    stakingDepositStatus: [types_1.StakingDepositStatus.ACTIVE],
    deposit: {
        tokenType: types_1.TokenType.ERC20,
        contractId: types_collection_1.InputType.awaited,
    },
    reward: {
        tokenType: types_1.TokenType.ERC721,
        contractId: types_collection_1.InputType.awaited,
    },
    emptyReward: false,
    startTimestamp: (0, date_fns_1.startOfMonth)((0, date_fns_1.subMonths)(new Date(), 1)).toISOString(),
    endTimestamp: (0, date_fns_1.endOfMonth)((0, date_fns_1.addMonths)(new Date(), 1)).toISOString(),
};
const stakingReportSearchValuesCreator = profile => ({
    [types_2.ServiceType.ADMIN]: {
        ...baseSearchValues,
    },
    [types_2.ServiceType.OFFICE]: {
        ...baseSearchValues,
        merchantId: profile.merchantId,
    },
});
exports.stakingReportSearchValuesCreator = stakingReportSearchValuesCreator;
//# sourceMappingURL=schemas.js.map